import { theme, lightTheme } from './theme'
import { appBarTheme } from './appBar'
import { buttonTheme } from './button'
import { formLabelTheme } from './form'
import {
  formHelperTextTheme,
  inputBaseTheme,
  inputLabelTheme,
  inputTheme,
  outlinedInputTheme,
  pickersOutlinedInputTheme,
  skeletonTheme,
} from './input'
import { tabsTheme, tabTheme } from './tab'
import { tableCellTheme, tableHeadTheme, tableRowTheme } from './table'
import { dialogContentTextTheme, dialogContentTheme, dialogTheme, dialogTitleTheme } from './dialog'
import { switchTheme } from './switch'
import { toolbarTheme } from './toolbar'
import { cssBaselineTheme } from './cssBaseline'
import { paperTheme } from './paper'
import { typographyTheme } from './typography'

const components = {
  MuiCssBaseline: cssBaselineTheme,
  MuiTypography: typographyTheme,
  MuiPaper: paperTheme,
  MuiAppBar: appBarTheme,
  MuiButton: buttonTheme,
  MuiFormLabel: formLabelTheme,
  MuiFormHelperText: formHelperTextTheme,
  MuiInput: inputTheme,
  MuiInputBase: inputBaseTheme,
  MuiInputLabel: inputLabelTheme,
  MuiOutlinedInput: outlinedInputTheme,
  MuiPickersOutlinedInput: pickersOutlinedInputTheme,
  MuiSkeleton: skeletonTheme,
  MuiTab: tabTheme,
  MuiTabs: tabsTheme,
  MuiToolbar: toolbarTheme,
  MuiTableCell: tableCellTheme,
  MuiTableRow: tableRowTheme,
  MuiTableHead: tableHeadTheme,
  MuiDialog: dialogTheme,
  MuiDialogTitle: dialogTitleTheme,
  MuiDialogContent: dialogContentTheme,
  MuiDialogContentText: dialogContentTextTheme,
  MuiSwitch: switchTheme,
}

theme.components = components
lightTheme.components = components

export default theme
export { lightTheme }
